import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MatNativeDateModule,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  DateAdapter,
} from '@angular/material/core';
import {
  MomentDateModule,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSortModule } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { SimplebarAngularModule } from 'simplebar-angular';
import { NgxChartsModule } from '@swimlane/ngx-charts';

import { ProfileMenuListComponent } from './components/profile-menu-list/profile-menu-list.component';
import { ConfirmDialogComponent } from '../shared/components/confirm-dialog/confirm-dialog.component';
import { ComponentNavbarComponent } from './components/component-navbar/component-navbar.component';
import { AddressDialogComponent } from './components/address-dialog/address-dialog.component';
import { HeaderNavbarComponent } from './components/header-navbar/header-navbar.component';
import { BridgeDialogComponent } from './components/bridge-dialog/bridge-dialog.component';
import { SideNavbarComponent } from './components/side-navbar/side-navbar.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ApiLoaderComponent } from './components/api-loader/api-loader.component';
import { IRoomComponent } from './components/institution/i-room/i-room.component';
import { IInfoComponent } from './components/institution/i-info/i-info.component';
import { AdminRoleInfoComponent } from './components/admin-role/admin-role-info/admin-role-info.component';
import { AppRoleInfoComponent } from './components/app-role/app-role-info/app-role-info.component';
import { AppUserInfoComponent } from './components/app-user/app-user-info/app-user-info.component';
import { ClassInfoComponent } from './components/class/class-info/class-info.component';
import { MdmInfoComponent } from './components/mdm/mdm-info/mdm-info.component';
import { OrgInfoComponent } from './components/org/org-info/org-info.component';
import { OrgPocComponent } from './components/org/org-poc/org-poc.component';
import { OrgConfigComponent } from './components/org/org-config/org-config.component';
import { InstVehicleComponent } from './components/institution/inst-vehicle/inst-vehicle.component';
import { InstCalenderComponent } from './components/institution/inst-calender/inst-calender.component';
import { InstGalleryComponent } from './components/institution/inst-gallery/inst-gallery.component';
import { ClassFeesComponent } from './components/class/class-fees/class-fees.component';
import { ClassDocumentComponent } from './components/class/class-document/class-document.component';
import { ClassExamComponent } from './components/class/class-exam/class-exam.component';
import { ClassStudentComponent } from './components/class/class-student/class-student.component';
import { OrgSettingComponent } from './components/org/org-setting/org-setting.component';
import { InstCmsComponent } from './components/institution/inst-cms/inst-cms.component';
import { StudentSearchComponent } from './components/search/student-search/student-search.component';
import { CommunicationDialogComponent } from './components/communication/communication-dialog/communication-dialog.component';
import { FileUploadModalComponent } from './components/file-upload/file-upload-modal.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { BulkDownloadComponent } from './components/bulkdownload/bulkdownload.component';
import { BulkUploadComponent } from './components/bulkupload/bulkupload.component';
import { ClassSubjectComponent } from './components/class/class-subject/class-subject.component';
import { ClassTimetableListComponent } from './components/class/class-timetable-list/class-timetable-list.component';
import { ClassTimetableDetailComponent } from './components/class/class-timetable-detail/class-timetable-detail.component';
import { CollegeInfoComponent } from './components/college/college-info/college-info.component';
import { AdminusrInfoComponent } from './components/adminusr/adminusr-info/adminusr-info.component';
import { SelectFilterPipe } from './select-filter.pipe';
import { MatStepperModule } from '@angular/material/stepper';
import { NoticeBoardConfigComponent } from './components/notice-board-config/notice-board-config.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { BankDetailsComponent } from '../dashboard/college/action/bank-details/bank-details.component';
import { ManualCreateLogComponent } from './components/manual-create-log/manual-create-log.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { JdpicollegemappopupComponent } from './components/jdpicollegemappopup/jdpicollegemappopup.component';
import { CheckAdminPassComponent } from './components/check-admin-pass/check-admin-pass.component';
import { DownloadcustomizedexcelComponent } from './components/downloadcustomizedexcel/downloadcustomizedexcel.component';
import { ImageViewerComponent } from './components/image-viewer/image-viewer.component';

@NgModule({
  declarations: [
    IInfoComponent,
    IRoomComponent,
    ApiLoaderComponent,
    SideNavbarComponent,
    BreadcrumbComponent,
    HeaderNavbarComponent,
    BridgeDialogComponent,
    AddressDialogComponent,
    ConfirmDialogComponent,
    ProfileMenuListComponent,
    ComponentNavbarComponent,
    AdminRoleInfoComponent,
    AppRoleInfoComponent,
    AppUserInfoComponent,
    ClassInfoComponent,
    MdmInfoComponent,
    OrgInfoComponent,
    OrgPocComponent,
    OrgConfigComponent,
    InstVehicleComponent,
    InstCalenderComponent,
    InstGalleryComponent,
    ClassFeesComponent,
    ClassDocumentComponent,
    ClassExamComponent,
    ClassStudentComponent,
    OrgSettingComponent,
    InstCmsComponent,
    StudentSearchComponent,
    CommunicationDialogComponent,
    FileUploadModalComponent,
    FileUploadComponent,
    BulkDownloadComponent,
    BulkUploadComponent,
    ClassSubjectComponent,
    ClassTimetableListComponent,
    ClassTimetableDetailComponent,
    CollegeInfoComponent,
    BankDetailsComponent,
    AdminusrInfoComponent,
    SelectFilterPipe,
    NoticeBoardConfigComponent,
    PdfViewerComponent,
    ManualCreateLogComponent,
    ChangePasswordComponent,
    JdpicollegemappopupComponent,
    CheckAdminPassComponent,
    DownloadcustomizedexcelComponent,
    ImageViewerComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    DragDropModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatListModule,
    MatMenuModule,
    MatCardModule,
    MatIconModule,
    MatSortModule,
    MatInputModule,
    MatTableModule,
    CKEditorModule,
    MatButtonModule,
    MatSelectModule,
    MatDialogModule,
    NgxChartsModule,
    MatTooltipModule,
    FlexLayoutModule,
    MatToolbarModule,
    MatSidenavModule,
    MomentDateModule,
    MatCheckboxModule,
    MatSnackBarModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatButtonToggleModule,
    SimplebarAngularModule,
    MatProgressSpinnerModule,
    NgxMaterialTimepickerModule,
    MatStepperModule,
    NgxExtendedPdfViewerModule
  ],
  exports: [
    FormsModule,
    DragDropModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatListModule,
    MatCardModule,
    MatMenuModule,
    MatIconModule,
    MatSortModule,
    IInfoComponent,
    IRoomComponent,
    MatInputModule,
    MatTableModule,
    CKEditorModule,
    MatButtonModule,
    MatSelectModule,
    MatDialogModule,
    NgxChartsModule,
    MatTooltipModule,
    FlexLayoutModule,
    MatToolbarModule,
    MatSidenavModule,
    MomentDateModule,
    MatCheckboxModule,
    MatSnackBarModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatFormFieldModule,
    SideNavbarComponent,
    BreadcrumbComponent,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatButtonToggleModule,
    HeaderNavbarComponent,
    BridgeDialogComponent,
    AddressDialogComponent,
    ConfirmDialogComponent,
    SimplebarAngularModule,
    MatProgressSpinnerModule,
    ProfileMenuListComponent,
    ComponentNavbarComponent,
    AdminRoleInfoComponent,
    AppRoleInfoComponent,
    AppUserInfoComponent,
    ClassInfoComponent,
    MdmInfoComponent,
    OrgInfoComponent,
    OrgPocComponent,
    OrgConfigComponent,
    InstVehicleComponent,
    InstCalenderComponent,
    InstGalleryComponent,
    ClassFeesComponent,
    ClassDocumentComponent,
    ClassExamComponent,
    ClassStudentComponent,
    ClassSubjectComponent,
    ClassTimetableListComponent,
    ClassTimetableDetailComponent,
    OrgSettingComponent,
    InstCmsComponent,
    StudentSearchComponent,
    CommunicationDialogComponent,
    FileUploadModalComponent,
    FileUploadComponent,
    BulkDownloadComponent,
    BulkUploadComponent,
    NgxMaterialTimepickerModule,
    CollegeInfoComponent,
    BankDetailsComponent,
    AdminusrInfoComponent,
    SelectFilterPipe,
    MatStepperModule,
    NoticeBoardConfigComponent,
    NgxExtendedPdfViewerModule,
    PdfViewerComponent,
    ManualCreateLogComponent
  ],
  providers: [
    // { provide: MAT_DATE_LOCALE, useValue: 'en-IN' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'D/M/YYYY',
        },
        display: {
          dateInput: 'DD/MM/YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'DD/MM/YYYY',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class SharedModule { } 
